import { render, staticRenderFns } from "./PermissionV2.vue?vue&type=template&id=f84dbcb0&scoped=true&"
import script from "./PermissionV2.vue?vue&type=script&lang=ts&"
export * from "./PermissionV2.vue?vue&type=script&lang=ts&"
import style0 from "./PermissionV2.vue?vue&type=style&index=0&id=f84dbcb0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f84dbcb0",
  null
  
)

export default component.exports